import { render, staticRenderFns } from "./surface_title.vue?vue&type=template&id=da731b4c&scoped=true&"
import script from "./surface_title.vue?vue&type=script&lang=ts&"
export * from "./surface_title.vue?vue&type=script&lang=ts&"
import style0 from "./surface_title.vue?vue&type=style&index=0&id=da731b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da731b4c",
  null
  
)

export default component.exports